import script from "./IframeBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./IframeBar.vue?vue&type=script&setup=true&lang=ts"

import "./IframeBar.vue?vue&type=style&index=0&id=f95a193a&lang=scss"

const __exports__ = script;

export default __exports__